import { Component } from "react";

const title = "Herox";
const desc = "7777 Unique NFT Items Herox";

let socialList = [
    {
        iconName: 'fab fa-twitter',
        siteLink: '#',
    },
    {
        iconName: 'fab fa-discord',
        siteLink: '#',
    },
    {
        iconName: 'fab fa-twitch',
        siteLink: '#',
    },
    {
        iconName: 'fab fa-instagram',
        siteLink: '#',
    },
]

class Footer extends Component {
    render() { 
        return (
            <footer className="footer">
                <div className="footer__wrapper padding-top padding-bottom" style={{backgroundImage: "url(/assets/images/footer/bg.png)"}}>
                    <div className="container">
                        <div className="footer__content text-center">
                            <h3>{title}</h3>
                            <p>{desc}</p>
                            <ul className="social justify-content-center">
                                {socialList.map((val, i) => (
                                    <li className="social__item" key={i}>
                                        <a href={val.siteLink} className="social__link"><i className={val.iconName}></i></a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="footer__copyright">
                    <div className="container">
                        <div className="text-center py-4">
                            <p className="mb-0">© 2022 Herox | All Rights Reserved <a href="https://www.templatemonster.com/authors/codexcoder" className="color__theme-color">CodexCoder</a></p>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}
 
export default Footer;